(function() {
function patchCard(card) {
  if (card.getAttribute("data-frcp-loyalty-applied") === "1") return;

  var originalPointsText = "";
  var existingPointsEl = card.querySelector(".kl-hub-p-small");
  if (existingPointsEl) {
    originalPointsText = existingPointsEl.innerText;
  }

  var newCard = card;
  if (card.tagName.toLowerCase() !== "a") {
    var anchor = document.createElement("a");
    anchor.className = card.className;
    anchor.innerHTML = card.innerHTML;
    card.parentNode.replaceChild(anchor, card);
    newCard = anchor;
  }

  newCard.classList.add("kl-hub-card-button");
  newCard.classList.add("Card-cardButton-qqxSu");
  newCard.setAttribute("data-frcp-loyalty-applied", "1");
  newCard.style.textDecoration = "none";
  newCard.style.color = "inherit";
  newCard.style.cursor = "pointer";

  newCard.onclick = function(e) {
    e.preventDefault();
    e.stopPropagation();
    if (window.frcp && frcp.loyalty && typeof frcp.loyalty.toggleLoyaltyWidget === "function") {
      frcp.loyalty.toggleLoyaltyWidget();
    }
    if (window.customerHubApi && typeof window.customerHubApi.close === "function") {
      window.customerHubApi.close();
    }
  };

  var cardContent = newCard.querySelector(".Card-cardContent-QaGRy");
  if (cardContent) {
    var html = "";
    html += "<div class=\"kl-hub-action-card__main ActionCard-mainContainer-SURE3\">";
    html += "<div class=\"Layout-box-B0piX\" style=\"--kl-local-box-flex: 1px; display: flex; justify-content: space-between; align-items: center;\">";
    html += "<h5 class=\"kl-hub-text Typography-h5-K9nOV Typography-typography-tDGQt Typography-heading-un7V6 Typography-bold-oySic Typography-noSpacing-nPRl1 kl-hub-heading kl-hub-h5\">Your Loyalty Points</h5>";
    html += "<p class=\"kl-hub-text Typography-p2-GhPtZ Typography-typography-tDGQt Typography-text-zqkXb Typography-noSpacing-nPRl1 kl-hub-p kl-hub-p-small\" style=\"font-weight: bold; background: #ededed; padding: 4px 8px 4px 8px; border-radius: 24px; margin-right: 0px;\">" + originalPointsText + "</p>";
    html += "</div>";
    html += "<span class=\"kl-hub-icon Icon-icon-s7xZm\" style=\"width: auto; height: auto; margin-left: 12px; display: flex;\">";
    html += "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" fill=\"none\" style=\"display: block; width: 16px; height: 16px;\">";
    html += "<path d=\"M5.5 3 11 8l-5.5 5\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\"></path>";
    html += "</svg>";
    html += "</span>";
    html += "</div>";
    cardContent.innerHTML = html;
  }
}

  function tryApply() {
    var cards = document.querySelectorAll(".kl-hub-content-block-froonze-points");
    for (var i = 0; i < cards.length; i++) {
      patchCard(cards[i]);
    }
  }

  tryApply();

  var debounceTimer = null;
  var observer = new MutationObserver(function() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(tryApply, 150);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  setInterval(tryApply, 400);
})();

(function() {
  function patchPointsPreview(el) {
    if (el.getAttribute("data-frcp-points-clickable") === "1") return;

    el.setAttribute("data-frcp-points-clickable", "1");
    el.style.cursor = "pointer";

    el.onclick = function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (window.frcp && frcp.loyalty && typeof frcp.loyalty.toggleLoyaltyWidget === "function") {
        frcp.loyalty.toggleLoyaltyWidget();
      }
    };
  }

  function tryApply() {
    var elements = document.querySelectorAll(".frcp-points-preview");
    for (var i = 0; i < elements.length; i++) {
      patchPointsPreview(elements[i]);
    }
  }

  tryApply();

  var debounceTimer = null;
  var observer = new MutationObserver(function() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(tryApply, 150);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  setInterval(tryApply, 400);
})();